<template>
  <v-container>
    <v-card class="mx-auto" flat>
      <!-- <v-row>
        <v-col>
          <p class="headline font-weight-bold" style="color:#2e9e91; font-size: 27px !important;">
            Reporte de Refrendos
          </p>
        </v-col>
      </v-row>
      <v-divider class="mb-9"></v-divider> -->
      <v-toolbar color="#676767" dark dense>
        <v-toolbar-title class="d-none d-sm-flex"><b>Reporte de solicitudes Nuevas, Refrendos y Reincorporaciones</b></v-toolbar-title>
      </v-toolbar>
      <br>
      <v-form @submit.prevent="save" ref="form" v-model="validateFolio" lazy-validation>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="folio"
              label="Número de Folio"
              :rules="numberRules"
              @blur="clear()"
              dense
              outlined
              clearable
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
              :items="listTipo"
              v-model="tipo"
              label="Tipo"
              item-value="value"
              item-text="nombre"
              dense
              outlined
              clearable
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              :items="listFiltro"
              v-model="filtro"
              label="Estatus"
              item-value="id"
              item-text="nombre"
              dense
              outlined
              clearable
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
              label="Periodos"
              return-object
              item-text="nombre"
              item-value="id"
              dense
              outlined
              :items="listPeriodos"
              v-model="periodo"
            ></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-card-actions>
              <!-- <v-spacer></v-spacer> -->
              <v-btn
                block
                color="#0277BD"
                class="white--text mt-n2"
                @click.native="validate()"
                :disabled="!validateFolio"
                :loading="loading"
                >Buscar
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <br>
      <div>
        <v-row>
          <v-col>
            <p class="overline">Resultados de la consulta <br>
              Total : {{ totalRegistros }}
            </p>
          </v-col>
          <v-spacer></v-spacer>
          <v-col align="right">
            <v-btn dark color="#616161" @click="getExcel()">Descargar Reporte</v-btn>
          </v-col>
        </v-row>
        <v-row class="mt-n6">
          <v-spacer></v-spacer>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              dense
              :headers="headers"
              :items="listRefrendos"
              item-value="id"
              item-text="nombre"
              class="elevation-1"
              :loading="loading"
              light
              actions
              hide-default-footer
              no-data-text="No se encontraron Refrendos"
              elevation="7"
              :items-per-page="per_page_table"
            >
            <template v-slot:item.nombre = "{item}">
              <td>{{ item.nombre }} {{ item.primer_apellido }} {{ item.segundo_apellido }}</td>
            </template>
            <template v-slot:item.tipo = "{item}">
              <div class="d-flex align-center">
                <td v-if="item.tipo == 1">Nueva</td>
                <td v-else-if="item.tipo == 2">Refrendo</td>
                <td v-else>Reincorporación</td>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="currentUser.roles[0].name === 'superadmin' || currentUser.roles[0].name === 'admin'"
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      @click="openEditTipo(item)"
                      color="blue darken-2"
                      class="ml-2"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar tipo de solicitud</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:item.fecha_presenta = "{item}">
              <div class="d-flex align-center">
                <span v-if="item.fecha_presenta == null">No Presentó</span>
                <span v-else>{{item.fecha_presenta}}</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="currentUser.roles[0].name === 'superadmin' || currentUser.roles[0].name === 'admin'"
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      @click="openEditFecha(item)"
                      color="orange darken-2"
                      class="ml-2"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar fecha de presentación</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:item.activo="{ item }">
              <v-icon
                  v-if="item.habilitado == 1"
                  class="mr-2"
                  color="green"
                >
                  mdi-checkbox-marked-circle-outline
              </v-icon>
              <v-icon
                  v-else
                  class="mr-2"
                >
                  mdi-minus
              </v-icon>
            </template>
            <template v-slot:item.action="{ item }">

                <v-tooltip top v-if="item.habilitado == 2">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      v-if="item.habilitado == 2"
                      x-small
                      dark
                      @click="peritoEnable(item)"
                      color="blue-grey"
                      >
                      <v-icon>mdi-account-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Habilitar Perito</span>
                </v-tooltip>

              <v-tooltip top v-if="item.habilitado == 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    v-if="item.habilitado == 1"
                    x-small
                    dark
                    @click="peritoEnable(item)"
                    color="blue-grey"
                    >
                    <v-icon>mdi-account-remove</v-icon>
                  </v-btn>
                </template>
                <span>Deshabilitar Perito</span>
              </v-tooltip>&nbsp;

              <v-btn
                v-if="item.fecha_presenta"
                x-small
                dark
                @click="AcusePdf(item)"
                color="blue"
                >
                <v-icon left x-small >mdi-file</v-icon>
                Ver Acuse
              </v-btn>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination
              v-if="pagination.total >= 1"
              v-model="pagination.current"
              :length="pagination.total"
              :total-visible="7"
              @input="onPageChange"
            ></v-pagination>
          </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-dialog v-model="dialogFecha" max-width="350">
      <v-card>
        <v-card-title class="subtitle-1 font-weight-bold grey lighten-3 py-3">
          <v-icon left color="blue darken-2">mdi-calendar-edit</v-icon>
          Editar Fecha de Presentación
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-date-picker
            v-model="editFecha"
            locale="es"
            full-width
            color="blue darken-2"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-btn small text color="red" @click="editFecha = null">
            <v-icon left small>mdi-close-circle</v-icon>Limpiar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small outlined @click="dialogFecha = false">Cancelar</v-btn>
          <v-btn small dark color="blue darken-2" :loading="loadingFecha" @click="guardarFecha()">
            <v-icon left small>mdi-content-save</v-icon>Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogTipo" max-width="380">
      <v-card>
        <v-card-title class="subtitle-1 font-weight-bold grey lighten-3 py-3">
          <v-icon left color="blue darken-2">mdi-swap-horizontal</v-icon>
          Cambiar Tipo de Solicitud
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-select
            v-model="editTipo"
            :items="tiposParaEditar"
            item-text="nombre"
            item-value="value"
            label="Tipo de solicitud"
            outlined
            dense
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn small outlined @click="dialogTipo = false">Cancelar</v-btn>
          <v-btn small dark color="blue darken-2" :loading="loadingTipo" @click="confirmarCambioTipo()">
            <v-icon left small>mdi-content-save</v-icon>Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="progress"
      persistent
      width="300"
    >
      <v-card
        color="blue"
        dark
      >
        <v-card-text>
          <b>Descargando Acuse</b>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
const Swal = require('sweetalert2');
  export default {
    data: () => ({
      progress: false,
      dialogFecha: false,
      editFecha: null,
      editSolicitudId: null,
      loadingFecha: false,
      dialogTipo: false,
      editTipo: null,
      editTipoSolicitudId: null,
      loadingTipo: false,
      tiposParaEditar: [
        { nombre: 'Nueva', value: 1 },
        { nombre: 'Refrendo', value: 2 },
        { nombre: 'Reincorporación', value: 3 },
      ],
      pagination: {
        current: 1,
        total: 0
      },
      per_page_table: 5,
      refrendosList:[],
      valid: true,
      filtro: null,
      periodo: '',
      folio: '',
      tipo: '',
      dialog: false,
      loading:false,
      validateFolio: true,
      totalRegistros: '',
      headers: [
        { text: 'Folio', value: 'folio', sortable: false  },
        { text: 'Nombre', value: 'nombre', sortable: false  },
        { text: 'Tipo', value: 'tipo', sortable: false},
        { text: 'Fecha de Presentación', value: 'fecha_presenta' },
        { text: 'Perito Activo', value: 'activo', sortable: false, align: 'center' },
        { text: 'Acciones', value: 'action', sortable: false, align: 'center' }
      ],
      listFiltro: [
        { id: '1', nombre: 'NO Presentado' },
        { id: '2', nombre: 'Presentado' },
      ],
      listTipo: [
        { id: '1', nombre: 'Nueva', value: 1 },
        { id: '2', nombre: 'Refrendo', value: 2 },
        { id: '3', nombre: 'Reincorporación', value: 3 },
      ],
      numberRules: [
        v => !v || /^([1-9][0-9]*)$/.test(v) || 'Ingrese Número de Folio Valido',
      ]
    }),
    computed:{
      ...mapGetters([
        "currentUser", "listRefrendos", "listPeriodos"
      ])
    },
    watch: {
      folio: function (val) {
        this.pagination.current = 1;
      },
      filtro: function (val) {
        this.pagination.current = 1;
      },
      periodo: function (val) {
        this.pagination.current = 1;
      },
    },
    mounted(){
      this.getPeriodos()
      // this.buscar()
    },
    methods:{
      validate() {
        if (this.$refs.form.validate()) {
          this.loading = true
          this.buscar()
        }
      },
      clear () {
        if (!this.folio) {
          this.$refs.form.resetValidation()
          this.validateFolio = true
        }
      },
      buscar() {
        this.loading = true;
        this.$store.dispatch("GET_REFRENDADOS_LIST", { url:"/solicitudes/refrendos?page="+ this.pagination.current,
          data: {
            folio: this.folio,
            tipo: this.tipo,
            fechaPresenta: this.filtro,
            periodo_id: this.periodo ? this.periodo.id : undefined,
          }
        })
        .then((response) => {
          // console.log(response);
          this.pagination.current = response.data.data.refrendos.current_page;
          this.pagination.total = response.data.data.refrendos.last_page;
          this.per_page_table = response.data.data.refrendos.per_page;
          this.refrendosList = response.data.data.refrendos.data;
          this.totalRegistros = response.data.data.refrendos.total;
          // this.refrendosList = this.refrendosList.length
          this.loading = false
        })
        .catch(error => {
          console.log(error);
        });
      },

      peritoEnable(item) {
        this.loading = true;
        var habilitado = '';
        if (item.habilitado == 1) {
          habilitado = 2
        } else {
          habilitado = 1
        }
        this.$store.dispatch("ACTIVAR_PERITO", { url:"/solicitud/"+item.solicitud_id+"/activar",
          data: {
            habilitado: habilitado
          }
        })
        .then((response) => {
          this.buscar();
          this.loading = false
        })
        .catch(error => {
          console.log(error);
        });
      },

      openEditFecha(item) {
        this.editSolicitudId = item.solicitud_id;
        this.editFecha = item.fecha_presenta || null;
        this.dialogFecha = true;
      },

      guardarFecha() {
        this.loadingFecha = true;
        this.$store.dispatch("ACTIVAR_PERITO", {
          url: "/solicitud/" + this.editSolicitudId + "/fecha-presenta",
          data: { fecha_presenta: this.editFecha }
        })
        .then(() => {
          this.dialogFecha = false;
          this.loadingFecha = false;
          this.$swal({
            icon: 'success',
            title: 'Fecha actualizada correctamente',
            timer: 1500,
            showConfirmButton: false
          });
          this.buscar();
        })
        .catch(error => {
          console.log(error);
          this.loadingFecha = false;
          this.$swal({
            icon: 'error',
            title: 'Error al actualizar la fecha',
            confirmButtonText: "Aceptar"
          });
        });
      },

      openEditTipo(item) {
        this.editTipoSolicitudId = item.solicitud_id;
        this.editTipo = item.tipo;
        this.dialogTipo = true;
      },

      confirmarCambioTipo() {
        this.$swal({
          icon: 'warning',
          title: '¿Está seguro de cambiar el tipo de solicitud?',
          text: 'Este cambio afectará los acuses y documentos que se generen a partir de esta solicitud.',
          showCancelButton: true,
          confirmButtonText: 'Sí, cambiar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#1565C0',
        }).then((result) => {
          if (result.value) {
            this.loadingTipo = true;
            this.$store.dispatch("ACTIVAR_PERITO", {
              url: "/solicitud/" + this.editTipoSolicitudId + "/tipo",
              data: { tipo: this.editTipo }
            })
            .then(() => {
              this.dialogTipo = false;
              this.loadingTipo = false;
              this.$swal({
                icon: 'success',
                title: 'Tipo de solicitud actualizada correctamente',
                timer: 1500,
                showConfirmButton: false
              });
              this.buscar();
            })
            .catch(error => {
              console.log(error);
              this.loadingTipo = false;
              this.$swal({
                icon: 'error',
                title: 'Error al actualizar el tipo',
                confirmButtonText: "Aceptar"
              });
            });
          }
        });
      },

      getPeriodos() {
        this.$store.dispatch("GET_PERIODOS",  { url: "periodos" } ).then(response => {
          this.listPeriodos.forEach(element => {
            if (element.activo == 1) {
              // this.periodoActivo = element
              this.periodo = element
            }
          });
          this.buscar();
        })
        .catch(err => {
          console.log(err);
        });
      },
      onPageChange() {
        this.buscar();
      },
      AcusePdf(item){
        // console.log(item);
        this.progress = true
        this.$store.dispatch("GET_PDF", { url:"/solicitud/"+ item.solicitud_id +"/acuse"
        }).then((response) => {
          this.progress = false
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          // let nombre = this.solicitud.perito_data.nombre
          // let primer_apellido = this.solicitud.perito_data.primer_apellido
          var periodo = this.periodo.nombre
          periodo = periodo.split(" ")
          var periodoName = periodo[0]+periodo[1]+periodo[2]
          // console.log(periodoName);
          link.setAttribute('download', 'Acuse_Refrendo_'+ item.nombre + '_' + item.primer_apellido + '_' + periodoName +'.pdf');
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          console.log(err);
          this.progress = false
          this.$swal({
            title: 'Error al descargar el PDF!!!',
            icon: 'error',
            timer: 1000,
          })
        });
      },
      getExcel(){
        this.progress = true
        this.$store.dispatch("GET_EXCEL", { url:"/solicitudes/"+this.periodo.id+"/reporte?tipo="+this.tipo+"&fechaPresenta="+this.filtro,
          data: {
            tipo: this.tipo,
            fechaPresenta: this.filtro
          }
        }).then((response) => {
          // console.log(response.data);
          this.progress = false
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }));
          const link = document.createElement('a');
          link.href = url;
          var periodo = this.periodo.nombre
          periodo = periodo.split(" ")
          var periodoName = periodo[0]+periodo[1]+periodo[2]
          // console.log(periodoName);
          link.setAttribute('download', 'reporte_'+periodoName+'.xlsx');
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          console.log(err);
          this.progress = false
          this.$swal({
            title: 'Error al descargar el Reporte!!!',
            icon: 'error',
            timer: 1000,
          })
        });
      },
    }
  }
</script>
